import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as customersActions from 'app/store/temporary/actions/customers.actions';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwCustomersApiService } from 'app/services/customers-api.service';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class CustomersEffects {
  loadCustomers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customersActions.loadCustomers),
      switchMap(({ loadOptions }) =>
        this.customersApiService.getCustomers(loadOptions).pipe(
          map((response) =>
            customersActions.loadCustomersSuccess({ response })
          ),
          catchError((error) =>
            of(customersActions.loadCustomersFailed({ error }))
          )
        )
      )
    )
  );

  createCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customersActions.createCustomer),
      switchMap(({ customer }) =>
        this.customersApiService.createCustomer(customer).pipe(
          switchMap(() => [
            customersActions.createCustomerSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_customer_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(customersActions.createCustomerFailed({ error }))
          )
        )
      )
    )
  );

  updateCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customersActions.updateCustomer),
      switchMap(({ customer }) =>
        this.customersApiService.updateCustomer(customer).pipe(
          switchMap((response) => [
            customersActions.updateCustomerSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_customer_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(customersActions.updateCustomerFailed({ error }))
          )
        )
      )
    )
  );

  deleteCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customersActions.deleteCustomer),
      switchMap(({ customer }) =>
        this.customersApiService.deleteCustomer(customer).pipe(
          switchMap(() => [
            customersActions.deleteCustomerSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_customer_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(customersActions.deleteCustomerFailed({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private customersApiService: MwCustomersApiService
  ) {}
}
